export const AppConstants = {
  SSO_AUTH_TOKEN_DETAIL: "SSO_AUTH_TOKEN_DETAIL",
  appUrls: {
    MASTERDATA: "/masterdata",
    USERS: "/masterdata/users",
    RETAILERS: "/masterdata/retailers",
    TEAMS: "/masterdata/teams",
    TREATMENTS: "/masterdata/treatments",
    CROPS: "/masterdata/crops",
    PRODUCTS: "/masterdata/products",
    COMBINED_PRODUCTS: "masterdata/combinedproducts",
    LOCATIONS: "/masterdata/locations",
    SEASON: "/masterdata/seasons",
    TREATMENT_PRODUCTS: "/masterdata/treatmentproducts",
    ONFARM_TREATMENT_PRODUCTS: "/masterdata/onfarmtreatmentproducts",
    INVENTORY: "/main/inventory",
    DASHBOARD: "/main/dashboard",
    TRIAL_EXPERIMENTS: "/main/trial-experiments",
    TRIAL_DETAILS: "/main/trial-experiments/trial-details",
    ONFARM_REPORTS: "/main/onfarm-reports",
    REGIONS: "/main/regions",
    MASTERCATALOG: "/main/mastercatalog",
    REPORT: "/main/report",
    H2H_TYPE: "/main/report/h2htype",
    H2H_REPORT: "/main/report/h2hreport",
    ADHOC: "/main/report/adhoc",
    DATA_COLLECTIONS: "/main/collectionlocation",
    TRIALS: "/main/trial/trials",
    PROTOCOLS: "/main/trial/protocol",
    EXPERIMENT_TRIAL_LOCATIONS: "main/trial/triallocations",
    EXPERIMENT_TRIAL_LOCATIONS_FIELDMAP: "/main/trial/triallocations",
    EXPERIMENT_TRIAL_LOCATIONS_CREATE_LOCATION:
      "/main/trial/triallocations/createlocation",
    EXPERIMENT_MAPPING_SHEET: "/main/trial/worksheets",
    EXPERIMENT_MAPPING_SHEET_TEAM: "/main/trial/worksheets",
    EXPERIMENT_TRIAL_LOCATIONS_BOOK: "main/trial/triallocations/locationbook",
    DEMOS: "/main/trial/demos",
    DEMO_INVENTORY: "/main/demo/demoInventory",
    DEMO_TRIALS: "/main/demo/demoTrial",
    DATA_COLLECTION_FIELDBOOK:
      "main/trial/triallocation/datacollection/fieldbook",
    DATA_COLLECTION_REPBOOK: "main/trial/triallocation/datacollection/repbook",
    DATA_COLLECTION_TREATMENT:
      "main/trial/triallocation/datacollection/treatment",
    DATA_COLLECTION_LABBOOKS:
      "main/trial/triallocation/datacollection/labbooks",
    DATA_COLLECTION_OBSERVATIONS:
      "main/trial/triallocation/datacollection/observations",
    DATA_COLLECTION_APPLICATIONS:
      "main/trial/triallocation/datacollection/applications",
    EXPERIMENT_TRIAL_LOCATION: "main/experiments/triallocation",
    TRIAL_PROTOCOL: "/main/trial/protocol",
    PRINTING: "main/more/printing",
    EXPORT: "/main/more/export",
    SEED_CALCULATION: "/main/more/seedcalculation",
    MASTER_CATALOG: "/main/mastercatalog",
    ENTRY_MEANS_REPORT: "/main/report/entrymeansreport",
    SELECT_APPLICATION: "/select",
    FIELD_BOOK_CATALOG: "/main/mastercatalog?type=fieldbookcatalog",
    REP_BOOK_CATALOG: "/main/mastercatalog?type=repbookcatalog",
    LAB_BOOK_CATALOG: "/main/mastercatalog?type=labbookcatalog",
    APPLICATIONS_CATALOG: "/main/mastercatalog?type=applicationscatalog",
    OBSERVATIONS_CATALOG: "/main/mastercatalog?type=observationscatalog",
  },
  pages: [
    { title: "Master Data", path: "/masterdata" },
    { title: "Users", path: "/masterdata/users" },
    { title: "Retailers", path: "/masterdata/retailers" },
    { title: "Crops", path: "/masterdata/crops" },
    { title: "Teams", path: "/masterdata/teams" },
    { title: "Treatments", path: "/masterdata/treatments" },
    { title: "Products", path: "/masterdata/products" },
    { title: "Products", path: "/masterdata/combinedproducts/"},
    { title: "Products", path: "/masterdata/combinedproducts/products"},
    { title: "Products", path: "/masterdata/combinedproducts/pending-products"},
    { title: "Locations", path: "/masterdata/locations" },
    { title: "Seasons", path: "/masterdata/seasons" },
    { title: "Treatment Products", path: "/masterdata/treatmentproducts" },
    { title: "Treatment Products", path: "/masterdata/onfarmtreatmentproducts" },
    { title: "Treatment Products", path: "/masterdata/onfarmtreatmentproducts/treatmentproducts" },
    { title: "Treatment Products", path: "/masterdata/onfarmtreatmentproducts/pendingtreatmentproducts" },
    { title: "Trial Experiments", path: "/main/trial-experiments" },
    { title: "Reports", path: "/main/onfarm-reports" },
    { title: "Regions", path: "/main/regions" },
  ],
  PAGE_TITLES: {
    TRIAL_LOCATIONS: "Trial Locations",
    EXPERIMENTS: "Experiments",
    FIELD_MAP: "Field Map",
    DATA_COLLECTION: "Data Collection",
    DEMO: "Demo",
    DEMOS: "Demos",
    DEMO_TRIAL: "Demo Trials",
    DEMO_INVENTORY: "Demo Inventory",
    TRIALS: "Trials",
    TRIAL: "Trial",
    WORKSHEET: "Worksheet",
    PROTOCOLS: "Protocols",
    PRINTING: "Printing",
    COMBINED_PRODUCTS: "Products",
    EXPORT: "Export",
    SEED_CALCULATION: "Seed Calculation",
    MASTER_CATALOG: "Master Catalog",
    ENTRY_MEANS_REPORT: "Entry Means Report",
    REPORT: "Report",
    TRIAL_EXPERIMENTS: "Trial Experiments",
    ONFARM_REPORTS: "Reports",
    REGIONS: "Regions",
    TRIAL_DETAILS: "Trial Details",
    ON_FARM_REPORT: "Report",
    FIELD_BOOK_CATALOG: "Field Book",
    REP_BOOK_CATALOG: "Rep Book",
    LAB_BOOK_CATALOG: "Lab Book",
    APPLICATIONS_CATALOG: "Applications",
    OBSERVATIONS_CATALOG: "Observations",
  },
  COMMON_TEXT: {
    SEARCH_HINT_TEXT: "Press enter to search",
    DELETE_CONFIRM_TITLE: "Delete Confirmation",
    UPDATE_CORFIRM_TITLE: "Enable On-Farm Update Confirmation",
    UPDATE_ENABLE_ONFARM_CONFIRM_TITLE: "Enable On-Farm Update Confirmation",
    APPROVE_CORFIRM_TITLE: "Approve Product Confirmation",
    LOGOUT_CONFIRM_TITLE: "Logout Confirmation",
    LOGOUT_CONFIRM_DESCRIPTION: "Are you sure you want to logout?",
    DELETE_CONFIRM_DESCRIPTION: "Are you sure you want to delete?",
    UPDATE_CONFIRM_DESCRIPTION: "Are you sure you want to update these products?",
    APPROVE_CONFIRM_DESCRIPTION: "Are you sure you want to approve this product?",
    MANDATORY_FIELDS_MISSING: "Mandatory fields are missing. Please update the required fields before proceeding. Click Yes to continue.",
    CONFIRM_DIALOG_OK: "OK",
    CONFIRM_DIALOG_YES: "Yes",
    CONFIRM_DIALOG_NO: "No",
    CONFIRM_DIALOG_SAVE: "Save",
    CONFIRM_DIALOG_DISCARD: "Discard",
    SHOW_ALL: "Show All",
    SEARCH_BY_USER_NAME: "Search By Name",
    SEARCH_BY_PRODUCT_NAME: "Search by Treatment Product",
    DISCARD_CONFIRM_DESCRIPTION:
      "All changes will be lost if you discard. Do you want to continue?",
    RESET_CONFIRM_DESCRIPTION:
      "Management related data will be lost. Do you want to continue ?",
    DISCARD_CONFIRM_TITLE: "Discard Confirmation",
    APPROVE_TREATMENT_PRODUCT_TITLE: "Approve Treatment Product Confirmation",
    APPROVE_TREATMENT_PRODUCT_DESCRIPTION: "Are you sure you want to approve this treatment product?",
    MISSING_MANDATORY_FIELDS_TITLE: "Missing Mandatory Fields",
    MISSING_MANDATORY_FIELDS_DESCRIPTION: "Mandatory fields are missing. Do you want to update?",
    SAVE_CONTINUE_CONFIRM: "Do you Want to Save or Continue?",
    SAVE: "Save",
    CONTINUE: "Continue",
    CANCEL: "Cancel",
    PROCEED: "PROCEED",
    ERROR_TITLE: "Error !",
    SAVE_CONFIRMATION: "Save Confirmation",
    SAMPLE_MESSAGE: "This sample does not belong to",
    SWITCH_DASHBOARD_CONFIRM_TITLE: "Switch Dashboard Confirmation",
    ALERT_TITLE: "Alert !",
    PRINT_CONFIRM_TITLE: "Print Confirmation",
    PRINT_GREEN_PACKETS_CONFIRMATION:"Are you sure you want to print green packets?",
  },
  APP_DEFAULT_FILTER: {
    SELECTED_CROP: "CORN",
  },

  APPLICATION_NAMES: {
    APD: "Answerplot",
    ONFARM: "On-farm",
  },

  APPLICATION_CODES: {
    APD: "apd",
    ANSWERPLOT: "answerplot",
    ONFARM: "onfarm",
  },

  SYSTEM_ADMIN_ID: 1,

  CUSTOM_EVENTS: {
    LOG_OUT_USER: "logoutUser",
  },
  DEFAULT_PAGE_SIZE: 50,
  DATA_COLLECTION_DEFAULT_PAGE_SIZE: 200,
  ATTRIBUTES_DEFAULT_PAGE_SIZE: 500,
  DROPDOWN_DEFAULT_PAGE_SIZE: 1000, 
  RECURSIVE_DATA_DEFAULT_PAGE_SIZE: 500, // To Be Checked if recurrsive apis can accept 1000 pagesize, if yes we will merge dropdown and recurrsive.
  DATA_COLLECTION_MAX_CHAR_LENGTH: 250,
  utmZonesList: [
    {
      zoneNumber: "Web Mercator",
      name: "1 Web Mercator",
      wkid: 102100,
    },
    {
      zoneNumber: 10,
      name: "10N",
      wkid: 26910,
    },
    {
      zoneNumber: 11,
      name: "11N",
      wkid: 26911,
    },
    {
      zoneNumber: 12,
      name: "12N",
      wkid: 26912,
    },
    {
      zoneNumber: 13,
      name: "13N",
      wkid: 26913,
    },
    {
      zoneNumber: 14,
      name: "14N",
      wkid: 26914,
    },
    {
      zoneNumber: 15,
      name: "15N",
      wkid: 26915,
    },
    {
      zoneNumber: 16,
      name: "16N",
      wkid: 26916,
    },
    {
      zoneNumber: 17,
      name: "17N",
      wkid: 26917,
    },
    {
      zoneNumber: 18,
      name: "18N",
      wkid: 26918,
    },
    {
      zoneNumber: 19,
      name: "19N",
      wkid: 26919,
    },
  ],
  placementOrderList: {
    LeftToRight: "LeftToRight",
    Serpentine: "Serpentine",
  },
  KIOSK: "kiosk", // value for kiosk mode
  APP_MODE: "APP_MODE", // key for localStorage for app mode kiosk or not
  USER_ROLE: "USER_ROLE", // key for localStorage for user role
};
